import { CurrencyBlock } from '@/components/CurrencyBlock';
import { WithLoader } from '@/components/WithLoader';
import { useConfigContext } from '@/context/configContext';
// import { MediaContributionTooltipContent } from '@/components/ContributionTooltips/MediaContributionTooltipContent';
// import { MediaInvestmentTooltipContent } from '@/components/ContributionTooltips/MediaInvestmentTooltipContent';
// import { TotalContributionTooltipContent } from '@/components/ContributionTooltips/TotalContributionTooltipContent';
import { useOptimizationSession } from '@/dashboards/CampaignOptimization/hooks/useOptimizationSession';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { useMemo } from 'react';

export const CampaignSummary = () => {
    const {
        data: {
            contributionTotal,
            contributionTotalWithNewMedia,
            suggestedBudgetData,
            optimized,
            // previousPeriodInvestmentTotal,
            // previous: { totalContribution, mediaContribution },
        },
        disabledChannels,
        optimizationBase,
        isDataLoading,
        isDataFetching,
    } = useOptimizationSession();

    const { formatNumber } = useConfigContext();
    const { contributionFormatter, variableNameMap } =
        useDashboardGlobalContext();

    const disabledChannelsNames = useMemo(
        () => disabledChannels.map((channel) => variableNameMap[channel]),
        [disabledChannels, variableNameMap],
    );

    const totalRecommendedBudget = useMemo(() => {
        return suggestedBudgetData
            .filter((row) => !disabledChannelsNames.includes(row.variable))
            .reduce((acc, row) => acc + row.recommendedBudget, 0);
    }, [suggestedBudgetData, disabledChannelsNames]);

    const displayTotalContribution =
        optimizationBase === 'total_kpi' && optimized?.totalKpi
            ? optimized.totalKpi
            : contributionTotalWithNewMedia;

    return (
        <div className="glass-tile p-6 flex-wrap">
            <div className="relative">
                <WithLoader isLoading={isDataLoading} isFetching={isDataFetching}>
                    <div className="flex justify-center gap-6 flex-wrap">
                        <CurrencyBlock
                            className="grow"
                            title="Media investments"
                            titleTooltip="How much money you plan to invest into media over the campaign period."
                            value={formatNumber(totalRecommendedBudget)}
                            // description={
                            //     <MediaInvestmentTooltipContent
                            //         formatNumber={formatNumber}
                            //         previousPeriodInvestmentTotal={
                            //             previousPeriodInvestmentTotal
                            //         }
                            //         totalRecommendedBudget={totalRecommendedBudget}
                            //     />
                            // }
                        />
                        <CurrencyBlock
                            className="grow"
                            title="Media Contribution"
                            titleTooltip="How much KPI is your media predicted to generate over the campaign period."
                            value={contributionFormatter(contributionTotal || 0)}
                            // description={
                            //     <MediaContributionTooltipContent
                            //         formatNumber={contributionFormatter}
                            //         mediaContributionTotal={contributionTotal}
                            //         previousMediaContributionTotal={
                            //             mediaContribution
                            //         }
                            //         mediaContributionShare={
                            //             contributionTotal /
                            //             contributionTotalWithNewMedia
                            //         }
                            //     />
                            // }
                        />
                        <CurrencyBlock
                            className="grow"
                            title="Total Contribution"
                            value={contributionFormatter(displayTotalContribution)}
                            titleTooltip="How much KPI in total (including media) are you predicted to generate over the campaign period."
                            // description={
                            //     <TotalContributionTooltipContent
                            //         formatNumber={contributionFormatter}
                            //         totalContribution={
                            //             displayTotalContribution
                            //         }
                            //         previousTotalContribution={totalContribution}
                            //     />
                            // }
                        />
                    </div>
                </WithLoader>
            </div>
        </div>
    );
};
